var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 30,
    viewBox: "0 0 103 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3789 6.72656V9.78516H35.2109V24H31.5781V9.78516H26.3867V6.72656H40.3789ZM50.832 20.4492H44.4688L43.2734 24H39.5L45.6641 6.72656H49.7422L55.8594 24H51.9453L50.832 20.4492ZM49.8242 17.4727L47.668 10.6758L45.4414 17.4727H49.8242ZM58.0625 6.72656H61.6719V20.8945H70.2266V24H58.0625V6.72656ZM83.5039 6.72656V9.78516H78.3359V24H74.7031V9.78516H69.5117V6.72656H83.5039ZM92.8438 24.4805C90.375 24.4805 88.4883 23.8086 87.1836 22.4648C85.4336 20.8164 84.5586 18.4414 84.5586 15.3398C84.5586 12.1758 85.4336 9.80078 87.1836 8.21484C88.4883 6.87109 90.375 6.19922 92.8438 6.19922C95.3125 6.19922 97.1992 6.87109 98.5039 8.21484C100.246 9.80078 101.117 12.1758 101.117 15.3398C101.117 18.4414 100.246 20.8164 98.5039 22.4648C97.1992 23.8086 95.3125 24.4805 92.8438 24.4805ZM96.2539 19.8398C97.0898 18.7852 97.5078 17.2852 97.5078 15.3398C97.5078 13.4023 97.0859 11.9062 96.2422 10.8516C95.4062 9.78906 94.2734 9.25781 92.8438 9.25781C91.4141 9.25781 90.2734 9.78516 89.4219 10.8398C88.5703 11.8945 88.1445 13.3945 88.1445 15.3398C88.1445 17.2852 88.5703 18.7852 89.4219 19.8398C90.2734 20.8945 91.4141 21.4219 92.8438 21.4219C94.2734 21.4219 95.4102 20.8945 96.2539 19.8398Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11499 0.56543L0 19.8717L13.2665 19.8777L7.11499 0.56543Z",
    fill: "#FFCE4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.80322L0.0533447 19.878H13.3406L19 6.80322Z",
    fill: "#9281FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0442 27.0001L13.3199 19.8716H0L13.0442 27.0001Z",
    fill: "#58E5FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/IconLogo.3b6c4da3.svg";
export { ForwardRef as ReactComponent };